<template lang="pug">
  .main-container.selected.row.width-100.middle.m-top-2
    .filter-selected.row.middle(v-for='filter in filters' v-if='getFilterLabel(filter)')
      span.text-normal.bold.blue.label(v-html='getFilterLabel(filter)')
      button.m-left-05.cursor-pointer(@click='removeSelectedFilter(filter)')
        simple-svg.blue-icon(:filepath='crossIcon' width="14px" height="14px")
</template>

<script>
import { mapState } from 'vuex'
import crossIcon from '@/assets/ic_cross.svg'
import { i18n } from '../../main'
import moment from 'moment'
import { capitalize } from '@amcharts/amcharts4/.internal/core/utils/Utils'
import { deepCopy } from '../../utils/object'
import { routes } from '../../router'
import { localesToMoment } from '../../constants/languages'

export default {
  data() {
    return {
      crossIcon
    }
  },
  watch: {
    locale() {
      this.$forceUpdate()
    }
  },
  computed: {
    ...mapState({
      subtopicInfo: state => state.newFeed.searchResults.subtopic.data,
      ephemerideInfo: state => state.newFeed.searchResults.ephemeride.data,
      feedFilters: state => state.newFeed.filters,
      locale: state => state.behavior.locale
    }),
    selectedFilters() {
      return this.$route.query
    },
    filters() {
      const selected = []
      Object
        .keys(this.$route.query)
        .forEach(key => {
          if (key === 'name' || key === 'authorName') selected.push({ name: key, value: decodeURI(this.$route.query[key]) })
          else {
            Array.isArray(this.$route.query[key])
              ? this.$route.query[key].forEach(value => selected.push({ name: key, value: Number(value) }))
              : selected.push({ name: key, value: Number(this.$route.query[key]) })
          }
        })
      return selected.filter(fil =>
        fil.name !== 'ephemerideLocale' &&
        fil.name !== 'section'
      )
    }
  },
  methods: {
    removeSelectedFilter({ name, value }) {
      const query = deepCopy(this.$route.query)
      if (name === 'ephemerideId') {
        delete query.ephemerideId
        delete query.ephemerideLocale
      } else if (name === 'authorName') {
        delete query.authorId
        delete query.authorName
      } else {
        Array.isArray(query[name])
          ? query[name] = query[name].filter(op => op !== value)
          : delete query[name]
        for (const key in query) {
          Array.isArray(query[key]) && query[key].length === 0 && delete query[key]
        }
      }
      this.$router.push({
        name: Object.keys(this.selectedFilters).length ? routes.search : routes.feedInitial,
        params: this.$route.params,
        query
      })
    },
    getFilterLabel(filter) {
      if (filter.name === 'topicIds') {
        return this.feedFilters.topicIds
          .find(op => op.id === Number(filter.value))
          .name
      } else if (filter.name === 'skillIds') {
        const skill = this.feedFilters.skillIds.find(op => op.id === Number(filter.value))
        return i18n.t(`skills.${skill.translationId}`)
      } else if (filter.name === 'months') {
        moment.locale(localesToMoment[this.locale])
        return moment
          .months()
          .map((month, index) => ({ label: capitalize(month), value: index + 1 }))
          .find(month => month.value === Number(filter.value)).label
      } else if (filter.name === 'ODSIds') {
        const ods = this.feedFilters.ODSIds.find(op => op.id === Number(filter.value))
        return i18n.t(`sdg.${ods.translationId}`)
      } else if (filter.name === 'ageRangeIds') {
        const age = this.feedFilters.ageRangeIds.find(op => op.id === Number(filter.value))
        return `
          <div class='age-option blue' style='--color: ${age.mainColor}'>
            ${i18n.t('resourceCard.agesTag', { min: age.minAge, max: age.maxAge })}
          </div>`
      } else if (filter.name === 'subjectIds') {
        const sub = this.feedFilters.subjectIds.find(op => op.id === Number(filter.value))
        return i18n.t(`subjects.${sub.translationId}`)
      } else if (filter.name === 'subtopicIds') {
        return this.subtopicInfo && this.subtopicInfo.name
      } else if (filter.name === 'ephemerideId') {
        return this.ephemerideInfo && this.ephemerideInfo.title
      } else if (filter.name === 'name') {
        return filter.value
      } else if (filter.name === 'authorName') {
        return filter.value
      } else return null
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/variables/sizes';

.selected{
  margin: 0 auto;
  margin-top: 20px;
  max-width: $content-size;
  gap: 10px;
  .filter-selected{
    padding: 5px 8px;
    background-color: $lighter-blue;
    border: 1px solid $blue;
    border-radius: 5px;
    /deep/ .label{
      color: $blue;
    }
  }
}
</style>
